export const environment = {
  production: true,
  allowedUrls: ['/api'],
  baseUrl: 'https://cloud-dev.3uvision.com',
  baseAclUrl: 'https://acl-dev.3uvision.com',
  baseHubUrl: 'https://cloud-dev.3uvision.com/hub/RemoteData',
  keycloakUrl: 'https://keycloak-dev.3uvision.com/realms/test',
  clientId: 'test-client',
  expectedBeVersion: '1.3.',
  useMessagePackSignalR: true
};
